import { OrderLocations } from "./order-location";
import React from "react";
import { CustomOrderT, OrderT } from "../../../../../domain";
import {
  ScoreDetailsIcon,
  TruckIcon,
} from "../../../../../../../shared/infrastructure";

type OrderNumberInformationProps =
  | {
      isDedicated?: true;
      order: CustomOrderT;
    }
  | {
      isDedicated?: false;
      order: OrderT;
    };

export const OrderNumberInformation = ({
  isDedicated = false,
  order,
}: OrderNumberInformationProps): React.ReactElement => {
  return (
    <section className="grid gap-[16px]">
      <OrderLocations
        isDedicated={isDedicated}
        marketScores={order.market_scores ?? {}}
        distance={order.distance ?? null}
        stops={!isDedicated ? (order as OrderT).stopsCount ?? null : null}
        locationA={
          isDedicated
            ? (order as CustomOrderT).origin
            : (order as OrderT).loads_origin
        }
        locationB={
          isDedicated
            ? (order as CustomOrderT).destination
            : (order as OrderT).loads_destination
        }
      />
      <section className="mx-auto grid grid-flow-col items-center gap-[12px] whitespace-nowrap">
        <TruckIcon width={35} height={35} />
        <span className="text-[16px] font-[700] capitalize">
          {order.equipment_type?.description?.toLowerCase() ?? "- -"}
        </span>
      </section>
      <section className="mx-auto grid w-[200px] content-start gap-[4px]">
        <section className="grid grid-flow-col justify-between gap-[10px] rounded-[5px] bg-[#3C7CF338] px-[12px] py-[4px] text-[10px]">
          <span className="text-[#484848]">Composite:</span>
          <span className="grid grid-flow-col gap-[4px] font-[700] text-[#000000]">
            <span>
              {order.market_scores?.composite_score
                ? Math.round(order.market_scores?.composite_score * 100) / 100
                : "- -"}
            </span>
            <ScoreDetailsIcon />
          </span>
        </section>
        <section className="grid grid-flow-col justify-between gap-[10px] rounded-[5px] bg-[#3C7CF338] px-[12px] py-[4px] text-[10px]">
          <span className="text-[#484848]">GS Rate</span>
          <span className="font-[700] text-[#000000]">
            {order.lookup_rate
              ? `${order.lookup_rate.toLocaleString("en-US")} USD`
              : "- -"}
          </span>
        </section>
        {!isDedicated && (
          <section className="grid grid-flow-col justify-between gap-[10px] rounded-[5px] bg-[#3C7CF338] px-[12px] py-[4px] text-[10px]">
            <span className="text-[#484848]">FW Rate</span>
            <span className="font-[700] text-[#000000]">
              {order.fw_rate
                ? `${order.fw_rate.toLocaleString("en-US")} USD`
                : "- -"}
            </span>
          </section>
        )}
      </section>
    </section>
  );
};
